import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
// import { ChooseIconComponent } from 'vhobjects-admin';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from 'vhobjects-service';

@Component({
  selector: 'atw-multi-language-admin-config',
  templateUrl: './multi-language-admin-config.component.html',
  styleUrls: ['./multi-language-admin-config.component.scss']
})
export class AtwMultiLanguageAdminConfig extends AtwUpdateDbComponent  implements OnInit {
 @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'dieu_chinh_mau_ngon_ngu',
      index: 0,
    },
    {
      title: 'dieu_chinh_vien_ngon_ngu',
      index: 1,
    },
    {
      title: 'dieu_chinh_mau_hop_thoai',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_hop_thoai',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_muc_hop_thoai',
      index: 4,
    },
    {
      title: 'dieu_chinh_mau_muc_hop_thoai',
      index: 5,
    },
    {
      title: 'cau_hinh_hieu_ung_ngon_ngu_da_chon',
      index: 6,
    },
    {
      title: 'cau_hinh_hieu_ung_hop_thoai',
      index: 7,
    },
  ];
  displayType = [
    { name: 'danh_sach_tha_xuong', type: 'dropdowns' },
    { name: 'danh_sach', type: 'list' },
  ]

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};

  dataAfterChange: any = {};
  arr_link_page: any;
  id_subproject: any = '';
  customize: any = {};
  configMode: 'basic' | 'advanced' = 'basic';
  codeEditLangName = '';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private matDialog: MatDialog,
    public themeService: ThemeService,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public vhEventMediator: VhEventMediator,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
    this.codeEditLangName = this.functionService.defaultLanguage;
  }

  ngOnInit(): void {
    this.initMissingData();
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/multi-language.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      if ([6, 7].includes(this.currentViewAll.index)) {
        const effectSub = this.currentViewAll.index == 6 ? '' : '_sub';
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[`${this.device}_animation${effectSub}_type`])
        if (this.config[`animation${effectSub}-selected`]?.id && this.config[`animation${effectSub}-selected`].id !== '000000') {
          this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config[`animation${effectSub}-selected`].id)?.[`customize${effectSub}`] ?? [];
        }
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    const targetMap = value.includes('sub') ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu13: false,
  };
  openMapSub: { [name: string]: boolean } = {
    submenu1: true, submenu2: false, submenu3: false, submenu4: false
  };

  /** 
   * Hàm này dùng để mở dialog của component icon
   */
  openDialogChooseIcon() {
    const dialogRef = this.matDialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.config.icon.name = result.icon;
        this.updateObject();
      }
    });
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm cập nhật background linear-gradient
   * @param classname : tên class muốn thay đổi
   * @param configname : tên config muốn thay đổi
   */
  updateBackgroundRgb(classname, configname) {
    if (this.config[configname].gradient_check) {
      this.class[classname]['background-image'] = "linear-gradient(" + this.config[configname]['gradient_direction'] + this.config[configname]['gradient_arr'] + ")";
    }
    else {
      this.class[classname]['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   * @param index : vị trí phần tử muốn xóa
   * @param classname : tên class muốn thay đổi
   * @param configname : tên config muốn thay đổi
   */
  deleteGradient(index, classname, configname) {
    if (this.config[configname][`gradient_arr`].length > 1) {
      this.config[configname][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb(classname, configname)
    }
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   * @param classname : tên class muốn thay đổi
   * @param configname : tên config muốn thay đổi
   */
  addGradient(value, classname, configname) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config[configname]
          : this.config[configname];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb(classname, configname);
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   * @param classname : tên class muốn thay đổi
   * @param configname : tên config muốn thay đổi
   */
  chooseOption(direction, event, classname, configname) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config[configname].gradient_type = direction.type;
      this.config[configname].gradient_direction = direction.direction;
      this.class[classname]['background-image'] = this.config[configname].gradient_type + '(' + this.config[configname].gradient_direction + this.config[configname].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  updateDistance(){
    const positions = {
      top: { top: `calc(100% + ${this.config.modal.distance}px)`, bottom: 'unset', left: '0', right: 'unset' },
      bottom: { bottom: `calc(100% + ${this.config.modal.distance}px)`, top: 'unset', left: '0', right: 'unset' },
      left: { left: `calc(100% + ${this.config.modal.distance}px)`, right: 'unset', top: '0', bottom: 'unset' },
      right: { right: `calc(100% + ${this.config.modal.distance}px)`, left: 'unset', top: '0', bottom: 'unset' }
    };
    
    // Chỉ cập nhật các giá trị liên quan mà không làm mất thuộc tính khác
    Object.assign(this.class['multi-language__modal'], positions[this.config.modal.position] || {});
    this.updateObject();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[6]);
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetailChild(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[7]);
  }

  /**
   *  Hàm này để xử lý hiệu ứng khi xuất hiện
   */
  openAnimationAppear() {
    this.customize = [
      {
        label: 'vi_tri_bat_dau',
        var: '--6f-transform',
        type: 'transform',
      },
      {
        label: 'vi_tri_ket_thuc',
        var: '--6t-transform',
        type: 'transform',
      },
      {
        label: 'do_trong_suot_bat_dau',
        var: '--6f-opacity',
        type: 'opacity',
      },
      {
        label: 'do_trong_suot_ket_thuc',
        var: '--6t-opacity',
        type: 'opacity',
      },
      {
        label: 'lop_bat_dau',
        var: '--6f-z-index',
        type: 'z-index',
      },
      {
        label: 'lop_ket_thuc',
        var: '--6t-z-index',
        type: 'z-index',
      },
      {
        label: 'thoi_gian_mot_chu_ky_hoat_canh_se_chay',
        var: '--6-animation-duration-shared',
        type: 'animation-duration',
      },
      {
        label: 'kieu_chay_hieu_ung',
        var: '--6-animation-timing-function-shared',
        type: 'animation-timing-function',
      },
    ];
  }

  initMissingData() {
    this.staticdata.lang_name ??= {};
    this.functionService.multi_languages.forEach(lang => {
      this.staticdata.lang_name[lang.code] ??= {};
      this.staticdata.lang_name[lang.code].name ??= '';
    });
    if (!this.class['toggle__flag-wrapper'])
      this.class['toggle__flag-wrapper'] = {
        'margin-top': "0px",
        'margin-left': "0px",
        'margin-bottom': "0px",
        'margin-right': "0px",
        'width': '20px',
        'height': '15px',
        'overflow': 'hidden',
        'box-shadow': 'none',
      };
    if (!this.class['toggle__flag'])
      this.class['toggle__flag'] = {
        'width': '100%',
        'height': '100%',
        'object-position': 'center',
        'object-fit': 'cover',
      };
    if (!this.class['modal__flag-wrapper'])
      this.class['modal__flag-wrapper'] = {
        'margin-top': "0px",
        'margin-left': "0px",
        'margin-bottom': "0px",
        'margin-right': "0px",
        'width': '20px',
        'height': '15px',
        'overflow': 'hidden',
        'box-shadow': 'none',
      };
    if (!this.class['modal__flag'])
      this.class['modal__flag'] = {
        'width': '100%',
        'height': '100%',
        'object-position': 'center',
        'object-fit': 'cover',
      };
    if (!this.class['multi-language__modal--item-wrapper'])
      this.class['multi-language__modal--item-wrapper'] = {
        "cursor": "pointer",
      }
    if (!this.class['multi-language']['cursor'])
      this.class['multi-language']['cursor'] = 'pointer';
    if (!this.class['multi-language__modal']['cursor'])
      this.class['multi-language__modal']['cursor'] = 'default';
    if (!this.config.modal_item)
      this.config.modal_item = {
        "gradient_arr": [
          "rgb(0, 0, 255)",
          "rgb(255, 255, 0)"
        ],
        "background": "#8c52ff",
        "gradient_check": false,
        "value_range": 1,
        "gradient_type": "linear-gradient",
        "value_parameter": 100,
        "gradient_direction": "",
        "position": "top",
        "distance": 4
      };
    if (!this.class['multi-language__toggle'])
      this.class['multi-language__toggle'] = {
        gap: '8px'
      };
    if (!this.class['multi-language__toggle--inner'])
      this.class['multi-language__toggle--inner'] = {
        gap: '8px'
      };
    if (!this.config.toggle?.flag?.['box-shadow'])
      this.config.toggle.flag['box-shadow'] = {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      };
    if (!this.config.modal?.flag?.['box-shadow'])
      this.config.modal.flag['box-shadow'] = {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      };
    if (!this.config.toggle?.['box-shadow'])
      this.config.toggle['box-shadow'] = {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      };
    if (!this.class['multi-language__list'])
      this.class['multi-language__list'] = {
        "width": "100%",
        "height": "100%",
        "padding-left": "0",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "gap": "8px",
        "flex-direction": "column",
        "margin": "0px",
      };
    if (!this.class['multi-language__list--item-wrapper'])
      this.class['multi-language__list--item-wrapper'] = {
        "cursor": "pointer",
        "position": "relative",
        "gap": "0",
      };
    if (!this.class['multi-language__list--item'])
      this.class['multi-language__list--item'] = {
        "font-weight": "normal",
        "font-style": "normal",
        "font-family": "'Roboto', sans-serif",
        "color": "#000000",
        "font-size": "14px",
        "transform": "normal",
        "text-decoration": "none",
        "text-align": "left",
        "flex": 1,
      };
    if (!this.class['multi-language__list--item-dot'])
      this.class['multi-language__list--item-dot'] = {
        "position": "absolute",
        "left": "-10px",
        "top": "50%",
        "width": "6px",
        "height": "6px",
        "background-color": "#000",
        "border-radius": "100px",
        "border": "2px solid #000",
        "transform": "translateY(-50%)"
      };
    if (!this.config.hasOwnProperty('show_dot_list')) this.config.show_dot_list = true;
    this.config.active_style ??= {};
    if (!this.config.active_style.background_color) 
      this.config.active_style.background_color = '#fff';
    if (!this.config.active_style.color) 
      this.config.active_style.color = '#000';
    if (!this.config.display_type) 
      this.config.display_type = 'dropdowns';
    if (!this.config.icon_before)
      this.config.icon_before = {
        "name": "language",
        "disable": false
      };
    if (!this.class['multi-language__icon--before'])
      this.class['multi-language__icon--before'] = {
        "font-size": "24px",
        "color": "#000"
      };

    const deviceAnimationRequired = {
      "--6f-transform": "translateY(0) translateX(0) perspective(0px) rotate(0deg) rotateX(0deg) rotateY(0deg)",
      "--6t-transform": "translateY(0) translateX(0) perspective(0px) rotate(0deg) rotateX(0deg) rotateY(0deg)",
      "--6f-opacity": "0",
      "--6t-opacity": "1",
      "--6f-z-index": "-1",
      "--6t-z-index": "-1",
      "--6f-visibility": "hidden",
      "--6t-visibility": "visible",
      "--6-animation-duration-shared": "0.5s",
      "--6-animation-timing-function-shared": "ease-in-out",
      "--6-animation": "multi-language-animate-6 var(--6-animation-duration-shared) var(--6-animation-timing-function-shared) 1",
      "--6-animation-direction": "alternate",
      "--6-animation-fill-mode": "forwards",

      "--6-transform": "var(--6f-transform)",
      "--6-opacity": "var(--6f-opacity)",
      "--6-visibility": "var(--6f-visibility)",
      "--6-z-index": "var(--6f-z-index)"
    };
    if (!this.staticdata['tablet_landscape_animation_type']) this.staticdata['tablet_landscape_animation_type'] = "none";
    if (!this.staticdata['mobile_portrait_animation_type']) this.staticdata['mobile_portrait_animation_type'] = "none";
    if (!this.staticdata['desktop_animation_type']) this.staticdata['desktop_animation_type'] = "none";
    if (!this.staticdata['tablet_portrait_animation_type']) this.staticdata['tablet_portrait_animation_type'] = "none";
    if (!this.staticdata['mobile_landscape_animation_type']) this.staticdata['mobile_landscape_animation_type'] = "none";
    if (!this.config['animation-selected']) this.config['animation-selected'] = { "id": "000000" };
    if (!this.config['animation_sub-selected']) this.config['animation_sub-selected'] = { "id": "000000" };
    if (!this.staticdata['tablet_landscape_animation']) this.staticdata['tablet_landscape_animation'] = { 'animation-6': deviceAnimationRequired };
    if (!this.staticdata['mobile_portrait_animation']) this.staticdata['mobile_portrait_animation'] = { 'animation-6': deviceAnimationRequired };
    if (!this.staticdata['desktop_animation']) this.staticdata['desktop_animation'] = { 'animation-6': deviceAnimationRequired };
    if (!this.staticdata['tablet_portrait_animation']) this.staticdata['tablet_portrait_animation'] = { 'animation-6': deviceAnimationRequired };
    if (!this.staticdata['mobile_landscape_animation']) this.staticdata['mobile_landscape_animation'] = { 'animation-6': deviceAnimationRequired };
  }

  /**
   * Cập nhật kiểu hiển thị của đa ngôn ngữ
   */
  handleDisplayType(event) {
    switch (event) {
      case 'dropdowns':
        this.class['multi-language'].height = '57px';
        break;
      case 'list':
        delete this.class['multi-language'].height;
        break;
    }
    this.updateObject();
  }
}
